import React from "react";

const AgentContext = React.createContext();

export const AgentProvider = AgentContext.Provider;
export const UserConsumer = AgentContext.Consumer;
export default AgentContext;
